import debounce from "./utils/debounce.js";
import components from "./utils/components.js";
import hello from "./utils/hello.js";
import loader from "./utils/loader.js";
import vendor from "./utils/vendor.js";

import LogoWebComponent from "./web-components/logo.js";
import MarqueeWebComponent from "./web-components/marquee.js";

window.addEventListener("load", () => {
    console.log("Let’s start 🚀");

    document.documentElement.classList.remove("is-loading");
    document.documentElement.classList.remove("is-ready");

    vendor();
    hello();
    loader(() => {
        components().init();
    });
});

window.addEventListener("resize", debounce(
    () => window.dispatchEvent(new CustomEvent("mtl.resized")))
);

// Web Components
window.customElements.define("mtl-logo", LogoWebComponent);
window.customElements.define("mtl-marquee", MarqueeWebComponent);

/**
 * @link https://barba.js.org/docs/advanced/recipes/#Scroll-position
 */
if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
}
